import React from 'react';
import { X, Database, User, ShoppingCart, Users,LayoutDashboard ,ClipboardList } from 'lucide-react';
import { NavLink } from "react-router-dom";
import { useUserStore } from "../store/AuthUserStore";




// SidebarItem component ke props ke liye interface
interface SidebarItemProps {
  to: string;
  icon: React.ReactNode;
  text: string;
  onClick: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ to, icon, text, onClick }) => {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) => `
        flex gap-1 items-center rounded-lg px-8 py-3 cursor-pointer transition-colors duration-200 
        ${isActive ? "bg-black text-white" : "text-gray-700 hover:bg-gray-100"}
      `}
    >
      {icon}
      <span className="ml-4 font-medium">{text}</span>
    </NavLink>
  );
};

// SideBar component ke props ke liye interface
interface SideBarProps {
  isOpen: boolean;
  onClose: () => void;
}

// navItems array ke har object ka type
interface NavItem {
  name: string;
  icon: React.ReactNode;
  path: string;
  permission?: boolean;
}

// Define the type for permissions
interface UserPermissions {
  designMaster?: boolean;
  sizeMaster?: boolean;
  userAdmin?: boolean;
  vendorMaster?: boolean;
  orderManagement?: boolean;
  
}

interface IUser {
  id: string;
  fullName: string;
  username: string;
  userRole: "admin" | "supervisor" | "employee";
  employeeType?: "Karigar" | "Master" | null;
  permissions: UserPermissions;
}

export const SideBar: React.FC<SideBarProps> = ({ isOpen, onClose }) => {
  const user = useUserStore((state) => state.user);
  const userPermissions: UserPermissions = user?.permissions || {
    designMaster: false,
    sizeMaster: false,
    userAdmin: false,
    vendorMaster: false,
    orderManagement: false,
  };

  const navItems: NavItem[] = [
    {
      name: 'Dashboard',
      icon: <LayoutDashboard size={20} />,
      path: '/',
      permission: user?.userRole === "admin"
    },
    {
      name: 'Masters',
      icon: <Database size={20} />,
      path: '/master',
      permission: userPermissions.designMaster || userPermissions.sizeMaster || userPermissions.vendorMaster || false
    },
    {
      name: 'User Management',
      icon: <User size={20} />,
      path: '/usermanagement',
      permission: userPermissions.userAdmin || false
    },
    {
      name: 'Order Management',
      icon: <ClipboardList  size={20} />,
      path: '/ordermanagement',
      permission: userPermissions.orderManagement || false
    },
    {
      name: 'Employee Dashboard',
      icon: <Users size={20} />,
      path: '/employeedashboard',
      permission: user?.userRole === "employee"
    },
  ];

  return (
    <>
      <div
        className={`w-68 bg-white border-r border-gray-200 h-full p-5
        fixed lg:relative left-0 top-16 bottom-0 lg:top-0 z-40
        transform ${isOpen ? "translate-x-0" : "-translate-x-full"}
        lg:translate-x-0 transition-transform duration-300 ease-in-out
        `}
      >
        <div className="flex justify-between items-center mb-5">
          <div>
            <h2 className="text-xs uppercase font-semibold tracking-wider mb-4 ml-3">
              MAIN MODULES
            </h2>
          </div>
          <button onClick={onClose} className="lg:hidden">
            <X size={20} />
          </button>
        </div>
        <nav className="flex flex-col gap-2">
          {navItems
            .filter((item) => item.permission) 
            .map((item) => (
              <SidebarItem
                key={item.name}
                to={item.path}
                icon={item.icon}
                text={item.name}
                onClick={onClose}
              />
            ))}
        </nav>
      </div>
    </>
  );
};
